export const CHANGE_NA_POPUP_FORM = 'CHANGE_NA_POPUP_FORM';

export function changeForm(name, value) {
  return {
    type: CHANGE_NA_POPUP_FORM,
    name,
    value,
  };
}
